const unionTerritoryStates = require('./config.js').configs.unionTerritoryStates;
const configs = require('./config.js').configs;
const defaultData = require('./default_data').data;
import axios from 'axios';

export const globalMixin = {
    data(){
        return{
            CurrentBusiness:null,
            Businesses:{ "BusinessList": null, "BusinessCount":0},
            TransactionSettings:{"businessId":null, "branchDivision":false, "beatRouteArea":false, "mrpWiseStock":false, "disableNegativeStock":false, "gstType":1},
            minDateSelection:"2022-04-01",
            // maxDateSelection:"2024-03-31",
            maxDateSelection:"2027-03-31",
            dashboard:{
                periodValue:"This Month",
                startDate:this.fn_getLocalDateFormat(),
                endDate:this.fn_getLocalDateFormat(), 
                defaultDateRange:'month'
            },
            dataObj:{
                reportTitle:"Ledger",
                itemName:null,
                itemId:null,
                itemObj:null,
                itemLabel:null,
                startDate:new Date(), 
                endDate:new Date(), 
                reportData:null,
                columns:null,
                footerColumns:null,
                detailReportId:null,
                openView:false,
                reportType:null,
                tableView:true,
                reportPreferences:null,
                selectedAccountGroupTypeId:null,
                selectedPeriod:null,
                disableClick:false,
                hideFilterBtn:false
            },
            reportFilterObj:{},
            reportFilters:null,
            offline:false,
            dialog_reconnect:false,
            // states:null,
            states:[{"isSystem":null,"itemId":"dc7d30ea-994b-4a00-a217-2e795de1a86b","itemName":"Andaman and Nicobar Islands","stateCode":"35"},{"isSystem":null,"itemId":"ef3e6ee7-891c-4339-9674-a3fb0c776175","itemName":"Andhra Pradesh","stateCode":"37"},{"isSystem":null,"itemId":"610565c6-2338-463f-9fe6-3f1ed5a307cc","itemName":"Arunachal Pradesh","stateCode":"12"},{"isSystem":null,"itemId":"88b0a33d-ed72-4e66-892f-438e189d6aeb","itemName":"Assam","stateCode":"18"},{"isSystem":null,"itemId":"28ed0b29-e511-4a5e-a0ee-6c0d3cb97001","itemName":"Bihar","stateCode":"10"},{"isSystem":null,"itemId":"7b561f3a-7034-40bd-b5fe-bd601852ada2","itemName":"Chandigarh","stateCode":"04"},{"isSystem":null,"itemId":"fb169660-7d3e-49a7-80ec-49af30453e8b","itemName":"Chhattisgarh","stateCode":"22"},{"isSystem":null,"itemId":"f94b1f86-e89c-4743-98ac-e781d6218144","itemName":"Dadra and Nagar Haveli","stateCode":"26"},{"isSystem":null,"itemId":"54780a4c-dd7e-44ee-8ea7-4e0af0e3635f","itemName":"Daman and Diu","stateCode":"25"},{"isSystem":null,"itemId":"913236d6-8d5d-4473-afb1-efac40c94073","itemName":"Delhi","stateCode":"07"},{"isSystem":null,"itemId":"038356db-535e-4947-b992-98e4146373d2","itemName":"Goa","stateCode":"30"},{"isSystem":null,"itemId":"e5c04b41-fcdd-4882-ae45-a4a6965ccd4a","itemName":"Gujarat","stateCode":"24"},{"isSystem":null,"itemId":"736dddc0-94cb-4fe3-b7f5-107898c7d96f","itemName":"Haryana","stateCode":"06"},{"isSystem":null,"itemId":"720e3fdd-4eb1-46bf-83a0-9c9b51ec5aba","itemName":"Himachal Pradesh","stateCode":"02"},{"isSystem":null,"itemId":"8a397855-db05-48bb-b2b1-bf507bb1257f","itemName":"Jammu and Kashmir","stateCode":"01"},{"isSystem":null,"itemId":"898c111b-b931-4053-92b7-1c4102f0e735","itemName":"Jharkhand","stateCode":"20"},{"isSystem":null,"itemId":"467a64e4-f246-4e94-a92a-ccbd6d4508b3","itemName":"Karnataka","stateCode":"29"},{"isSystem":null,"itemId":"310005b0-d3fa-4e4a-85c2-2c7badb77b56","itemName":"Kerala","stateCode":"32"},{"isSystem":null,"itemId":"5a214644-789c-47b9-8779-0f26d5ba87c5","itemName":"Lakshadweep","stateCode":"31"},{"isSystem":null,"itemId":"ab895615-cbd6-418c-bdf2-e20f5775c650","itemName":"Madhya Pradesh","stateCode":"23"},{"isSystem":null,"itemId":"50f754d0-ed75-4b6c-a491-f0084a8feb6b","itemName":"Maharashtra","stateCode":"27"},{"isSystem":null,"itemId":"d850080e-1afa-42b5-9bc6-8c66c8c7c408","itemName":"Manipur","stateCode":"14"},{"isSystem":null,"itemId":"31b99dd8-7145-4098-bfc0-f8a4889877a1","itemName":"Meghalaya","stateCode":"17"},{"isSystem":null,"itemId":"c11557d4-8cac-4d74-87b3-7084af8167a3","itemName":"Mizoram","stateCode":"15"},{"isSystem":null,"itemId":"08733368-87ae-47e8-9b48-935b1278b264","itemName":"Nagaland","stateCode":"13"},{"isSystem":null,"itemId":"7b416c8b-b8b0-4fb1-9138-3e5bce7beb7c","itemName":"Odisha","stateCode":"21"},{"isSystem":null,"itemId":"b9f376f2-bcd8-49f8-9d2e-5c6c38682d2a","itemName":"Puducherry","stateCode":"34"},{"isSystem":null,"itemId":"874cefad-8157-4fae-8453-b730e6163719","itemName":"Punjab","stateCode":"03"},{"isSystem":null,"itemId":"7733da99-ecf5-4438-a6d9-f06e3df4f489","itemName":"Rajasthan","stateCode":"08"},{"isSystem":null,"itemId":"d93f79df-85fe-4107-8c01-f9ea9eb7b68b","itemName":"Sikkim","stateCode":"11"},{"isSystem":null,"itemId":"33cfc34b-3c95-4f51-af3b-1f8fdb9970ff","itemName":"Tamil Nadu","stateCode":"33"},{"isSystem":null,"itemId":"749905c5-c59b-44da-8342-50c5fbd78d5a","itemName":"Telangana","stateCode":"36"},{"isSystem":null,"itemId":"db6864ca-8e17-4784-984a-9df09b76fcdb","itemName":"Tripura","stateCode":"16"},{"isSystem":null,"itemId":"87242b71-594a-4899-b145-44e4a3f4c4ee","itemName":"Uttar Pradesh","stateCode":"09"},{"isSystem":null,"itemId":"ffcd8332-fffc-44b7-980a-c8dc06fc39ea","itemName":"Uttarakhand","stateCode":"05"},{"isSystem":null,"itemId":"9fedd066-4629-46e9-a286-2f5853157cbd","itemName":"West Bengal","stateCode":"19"},{"isSystem":null,"itemId":"3f2b2c71-9d44-4b60-b8b7-392c7e6a4a55","itemName":"Ladakh","stateCode":"38"}],

            //for backup data
            backupInProgress:false,
            uploadStatus:null,

            reconnectObj:{
                isConnecting:false,
                isDisconnected:false,
                isReconnecting:false,
                isDialogOpen:false,
                stopWebRtcConnection:false
                // isTimeOut:false
            },

            connectionNumber:null,

            dialog_customer_support:false,

            hasClientBusinesses:false,
            snackbar:false,
            snackbarMessage:null,
            snackbarIsVertical:false,
            snackbarTimeout:null,
            // baseApiUrl:process.env.NODE_ENV === 'production' ? "https://bizopsappapi.azurewebsites.net" : process.env.NODE_ENV === 'staging' ? "https://uatbizopsappapi.azurewebsites.net" : "https://devbizopsappapi.azurewebsites.net",
            baseApiUrl:process.env.VUE_APP_BASE_API_URL,
            viaKeyboardShortCut:false,
            isOfferCreated:false,
            mainBusinessID:null,
            appVersion:null,
            uniqueIds:[],
            products:[],
            ledgers:[],
            dialogLoader:false,
            infoDrawer:false,
            defaultStates:[{"isSystem":null,"itemId":"dc7d30ea-994b-4a00-a217-2e795de1a86b","itemName":"Andaman and Nicobar Islands","stateCode":"35"},{"isSystem":null,"itemId":"ef3e6ee7-891c-4339-9674-a3fb0c776175","itemName":"Andhra Pradesh","stateCode":"37"},{"isSystem":null,"itemId":"610565c6-2338-463f-9fe6-3f1ed5a307cc","itemName":"Arunachal Pradesh","stateCode":"12"},{"isSystem":null,"itemId":"88b0a33d-ed72-4e66-892f-438e189d6aeb","itemName":"Assam","stateCode":"18"},{"isSystem":null,"itemId":"28ed0b29-e511-4a5e-a0ee-6c0d3cb97001","itemName":"Bihar","stateCode":"10"},{"isSystem":null,"itemId":"7b561f3a-7034-40bd-b5fe-bd601852ada2","itemName":"Chandigarh","stateCode":"04"},{"isSystem":null,"itemId":"fb169660-7d3e-49a7-80ec-49af30453e8b","itemName":"Chhattisgarh","stateCode":"22"},{"isSystem":null,"itemId":"f94b1f86-e89c-4743-98ac-e781d6218144","itemName":"Dadra and Nagar Haveli","stateCode":"26"},{"isSystem":null,"itemId":"54780a4c-dd7e-44ee-8ea7-4e0af0e3635f","itemName":"Daman and Diu","stateCode":"25"},{"isSystem":null,"itemId":"913236d6-8d5d-4473-afb1-efac40c94073","itemName":"Delhi","stateCode":"07"},{"isSystem":null,"itemId":"038356db-535e-4947-b992-98e4146373d2","itemName":"Goa","stateCode":"30"},{"isSystem":null,"itemId":"e5c04b41-fcdd-4882-ae45-a4a6965ccd4a","itemName":"Gujarat","stateCode":"24"},{"isSystem":null,"itemId":"736dddc0-94cb-4fe3-b7f5-107898c7d96f","itemName":"Haryana","stateCode":"06"},{"isSystem":null,"itemId":"720e3fdd-4eb1-46bf-83a0-9c9b51ec5aba","itemName":"Himachal Pradesh","stateCode":"02"},{"isSystem":null,"itemId":"8a397855-db05-48bb-b2b1-bf507bb1257f","itemName":"Jammu and Kashmir","stateCode":"01"},{"isSystem":null,"itemId":"898c111b-b931-4053-92b7-1c4102f0e735","itemName":"Jharkhand","stateCode":"20"},{"isSystem":null,"itemId":"467a64e4-f246-4e94-a92a-ccbd6d4508b3","itemName":"Karnataka","stateCode":"29"},{"isSystem":null,"itemId":"310005b0-d3fa-4e4a-85c2-2c7badb77b56","itemName":"Kerala","stateCode":"32"},{"isSystem":null,"itemId":"5a214644-789c-47b9-8779-0f26d5ba87c5","itemName":"Lakshadweep","stateCode":"31"},{"isSystem":null,"itemId":"ab895615-cbd6-418c-bdf2-e20f5775c650","itemName":"Madhya Pradesh","stateCode":"23"},{"isSystem":null,"itemId":"50f754d0-ed75-4b6c-a491-f0084a8feb6b","itemName":"Maharashtra","stateCode":"27"},{"isSystem":null,"itemId":"d850080e-1afa-42b5-9bc6-8c66c8c7c408","itemName":"Manipur","stateCode":"14"},{"isSystem":null,"itemId":"31b99dd8-7145-4098-bfc0-f8a4889877a1","itemName":"Meghalaya","stateCode":"17"},{"isSystem":null,"itemId":"c11557d4-8cac-4d74-87b3-7084af8167a3","itemName":"Mizoram","stateCode":"15"},{"isSystem":null,"itemId":"08733368-87ae-47e8-9b48-935b1278b264","itemName":"Nagaland","stateCode":"13"},{"isSystem":null,"itemId":"7b416c8b-b8b0-4fb1-9138-3e5bce7beb7c","itemName":"Odisha","stateCode":"21"},{"isSystem":null,"itemId":"b9f376f2-bcd8-49f8-9d2e-5c6c38682d2a","itemName":"Puducherry","stateCode":"34"},{"isSystem":null,"itemId":"874cefad-8157-4fae-8453-b730e6163719","itemName":"Punjab","stateCode":"03"},{"isSystem":null,"itemId":"7733da99-ecf5-4438-a6d9-f06e3df4f489","itemName":"Rajasthan","stateCode":"08"},{"isSystem":null,"itemId":"d93f79df-85fe-4107-8c01-f9ea9eb7b68b","itemName":"Sikkim","stateCode":"11"},{"isSystem":null,"itemId":"33cfc34b-3c95-4f51-af3b-1f8fdb9970ff","itemName":"Tamil Nadu","stateCode":"33"},{"isSystem":null,"itemId":"749905c5-c59b-44da-8342-50c5fbd78d5a","itemName":"Telangana","stateCode":"36"},{"isSystem":null,"itemId":"db6864ca-8e17-4784-984a-9df09b76fcdb","itemName":"Tripura","stateCode":"16"},{"isSystem":null,"itemId":"87242b71-594a-4899-b145-44e4a3f4c4ee","itemName":"Uttar Pradesh","stateCode":"09"},{"isSystem":null,"itemId":"ffcd8332-fffc-44b7-980a-c8dc06fc39ea","itemName":"Uttarakhand","stateCode":"05"},{"isSystem":null,"itemId":"9fedd066-4629-46e9-a286-2f5853157cbd","itemName":"West Bengal","stateCode":"19"},{"isSystem":null,"itemId":"3f2b2c71-9d44-4b60-b8b7-392c7e6a4a55","itemName":"Ladakh","stateCode":"38"}],
            defaultCountries:[{"isSystem":null,"itemId":"5b4336c4-3842-4d75-8557-9bc9d5f4a77d","itemName":"Afghanistan"},{"isSystem":null,"itemId":"935f20e9-5557-4d50-8ea5-c0a1114b0d34","itemName":"Albania"},{"isSystem":null,"itemId":"1a4fba93-4d5e-4711-8cf8-960d4f303949","itemName":"Algeria"},{"isSystem":null,"itemId":"81e1be05-3b7d-4d7c-ae8c-54bba6c90616","itemName":"American Samoa"},{"isSystem":null,"itemId":"63ca93c9-a1f9-44da-83ff-6c671293a813","itemName":"Andorra"},{"isSystem":null,"itemId":"a65ac591-59ff-48fb-a584-eecb400c5a40","itemName":"Angola"},{"isSystem":null,"itemId":"ea25193f-60d6-4672-9cf8-ff530dd83fb5","itemName":"Anguilla"},{"isSystem":null,"itemId":"c783a9c8-6cc9-4301-acae-a40a4461951d","itemName":"Antarctica"},{"isSystem":null,"itemId":"dd75ffd8-9093-4ac3-99af-5dbfe97326f8","itemName":"Antigua and Barbuda"},{"isSystem":null,"itemId":"ee40a342-516c-4781-a5f8-f7c941776970","itemName":"Argentina"},{"isSystem":null,"itemId":"22a19f3c-0efa-4a08-893f-b99dc804d818","itemName":"Armenia"},{"isSystem":null,"itemId":"3d9550cb-65e1-442c-abcd-dc32186b07ec","itemName":"Aruba"},{"isSystem":null,"itemId":"28449439-c56e-4d14-8eed-607ec3c84a1e","itemName":"Australia"},{"isSystem":null,"itemId":"aedab8fa-c659-4050-a34c-a8f9304c9e84","itemName":"Austria"},{"isSystem":null,"itemId":"e7c75b6f-59c7-4c69-951e-071c5425d7b2","itemName":"Azerbaijan"},{"isSystem":null,"itemId":"0f878ab0-f57a-4794-8c48-5be59ab49fd8","itemName":"Bahamas"},{"isSystem":null,"itemId":"0eff8595-d28d-4ada-93f2-88fc19319d01","itemName":"Bahrain"},{"isSystem":null,"itemId":"c919ae7e-8f51-4b1f-9d68-3f57af251991","itemName":"Bangladesh"},{"isSystem":null,"itemId":"df2eda07-fddd-48f2-a09a-14478dac6a9f","itemName":"Barbados"},{"isSystem":null,"itemId":"0a2a0c36-a7d6-47ea-8b21-a56781a2e2bf","itemName":"Belarus"},{"isSystem":null,"itemId":"232cebf2-3e5d-4008-bc53-6d11aa3c0745","itemName":"Belgium"},{"isSystem":null,"itemId":"1ce7007e-b426-4cc7-bba1-50c80faa14a2","itemName":"Belize"},{"isSystem":null,"itemId":"a8921ceb-e97d-4488-a17a-cf1e6137092c","itemName":"Benin"},{"isSystem":null,"itemId":"f82f21b9-26a0-440f-8c5e-1641dbf2a99f","itemName":"Bermuda"},{"isSystem":null,"itemId":"9c0d28eb-e152-4c12-909d-15a489cc45f5","itemName":"Bhutan"},{"isSystem":null,"itemId":"f6b1b2b7-34ab-437d-ad9c-c795832ff12f","itemName":"Bolivia"},{"isSystem":null,"itemId":"47b812df-7c11-4d40-b45c-36951203ff15","itemName":"Bosnia and Herzegovina"},{"isSystem":null,"itemId":"ad3c3a91-3acc-403d-981d-8ddacb9d83dd","itemName":"Botswana"},{"isSystem":null,"itemId":"4a11acb4-80b5-4433-b046-2fd7f88cfc09","itemName":"Brazil"},{"isSystem":null,"itemId":"20d983d3-90a0-40c8-9aa9-25a7cfc599e4","itemName":"British Indian Ocean Territory"},{"isSystem":null,"itemId":"585a0a19-ffc4-4f4a-9bfe-c62fc9706dd4","itemName":"British Virgin Islands"},{"isSystem":null,"itemId":"65ae4789-b331-44d8-8b03-90df611a68ba","itemName":"Brunei"},{"isSystem":null,"itemId":"5be3e431-0a7a-41a2-8792-66d8d8079fad","itemName":"Bulgaria"},{"isSystem":null,"itemId":"7ed58c18-1933-434b-80e4-03f057a1df6e","itemName":"Burkina Faso"},{"isSystem":null,"itemId":"51c76507-109b-4953-a3fc-727921bce578","itemName":"Burundi"},{"isSystem":null,"itemId":"d8cc1cbc-3f66-4e62-9ee5-80311f29c4bf","itemName":"Cambodia"},{"isSystem":null,"itemId":"92bc046f-83d7-443c-a563-f63a610f421d","itemName":"Cameroon"},{"isSystem":null,"itemId":"25d06a73-dd3d-408e-a9eb-c9077e6c74b1","itemName":"Canada"},{"isSystem":null,"itemId":"e8f67960-abd4-4390-aa5c-d286ae435f88","itemName":"Cape Verde"},{"isSystem":null,"itemId":"cba620ab-7bb9-455b-a408-fc25a5ed2547","itemName":"Cayman Islands"},{"isSystem":null,"itemId":"683e8ef5-dd91-48c5-8ed2-6c5afc0ef3d0","itemName":"Central African Republic"},{"isSystem":null,"itemId":"83cf7359-ea0b-496c-b8e4-b7de297c4c1e","itemName":"Chad"},{"isSystem":null,"itemId":"3436cc95-bff6-411d-aefe-0ce7d5478899","itemName":"Chile"},{"isSystem":null,"itemId":"e898aaca-15af-4d15-8a5a-edc03ee73aae","itemName":"China"},{"isSystem":null,"itemId":"ba01ecd7-6e51-4bb4-86de-94d9fc28503a","itemName":"Christmas Island"},{"isSystem":null,"itemId":"a1e3d926-7ee9-4422-bb0e-1d355d80ba8b","itemName":"Cocos Islands"},{"isSystem":null,"itemId":"2ff02d82-9d77-4a39-ace1-3bc40b58f64c","itemName":"Colombia"},{"isSystem":null,"itemId":"91bd7abc-27b9-4abe-8cc9-5d98c350c0e9","itemName":"Comoros"},{"isSystem":null,"itemId":"12ac367e-c8b1-41b5-9d46-adaac847db25","itemName":"Cook Islands"},{"isSystem":null,"itemId":"1e982fa0-739f-493f-a08a-a8fdcf0a79e1","itemName":"Costa Rica"},{"isSystem":null,"itemId":"d08b772d-3056-4cd1-8ed2-fc2654c90c0c","itemName":"Croatia"},{"isSystem":null,"itemId":"8ea920bd-f4f9-40dc-86e5-f56d3ce38e93","itemName":"Cuba"},{"isSystem":null,"itemId":"48e73d01-72c5-4bab-a2f1-90e72291dd57","itemName":"Curacao"},{"isSystem":null,"itemId":"8ee939f4-9df3-4b83-8040-c6be665bdfbc","itemName":"Cyprus"},{"isSystem":null,"itemId":"4a494ffb-0523-4bb7-b24b-ed6d56515dfb","itemName":"Czech Republic"},{"isSystem":null,"itemId":"4c95e555-6f8e-4021-addb-6e0ff0ac5d88","itemName":"Democratic Republic of the Congo"},{"isSystem":null,"itemId":"b22c3b57-c679-489a-8a94-e3f3e3d36e17","itemName":"Denmark"},{"isSystem":null,"itemId":"f94f0841-42a0-4374-8d08-3bcbe3630e91","itemName":"Djibouti"},{"isSystem":null,"itemId":"30bb4138-620d-43b9-8291-da42e3b5c4a1","itemName":"Dominica"},{"isSystem":null,"itemId":"7c09094c-44a0-4445-bbc3-781a30b28925","itemName":"Dominican Republic"},{"isSystem":null,"itemId":"6d0a6c29-39d1-4c5f-8bbd-82fd43d9a0fc","itemName":"East Timor"},{"isSystem":null,"itemId":"11391123-607e-43b0-9c1d-823386a661f6","itemName":"Ecuador"},{"isSystem":null,"itemId":"43edf9af-eecc-4342-8e54-87cf25ad0ed4","itemName":"Egypt"},{"isSystem":null,"itemId":"4915ced4-252b-465e-9967-b5d35c02da35","itemName":"El Salvador"},{"isSystem":null,"itemId":"bf29664b-20fd-4016-a554-90d7b91a6d8a","itemName":"Equatorial Guinea"},{"isSystem":null,"itemId":"603c91a9-2d09-4715-b5de-3290f331c15c","itemName":"Eritrea"},{"isSystem":null,"itemId":"e3d61ed4-c0d7-4f3a-833e-f162a6da73f1","itemName":"Estonia"},{"isSystem":null,"itemId":"4e9aeebe-a55b-4998-bba1-ff561c33d48c","itemName":"Ethiopia"},{"isSystem":null,"itemId":"9c3cab35-9fa9-4931-b0fb-24e93b18c793","itemName":"Falkland Islands"},{"isSystem":null,"itemId":"a7fb349f-6147-4066-bc23-286ce7125655","itemName":"Faroe Islands"},{"isSystem":null,"itemId":"b1e4b350-5b6b-48b7-a032-55d8059d77a3","itemName":"Fiji"},{"isSystem":null,"itemId":"925d5ee9-3379-49e2-81c0-825e564423a7","itemName":"Finland"},{"isSystem":null,"itemId":"c7b91757-634c-4801-8a87-e977a586b9fa","itemName":"France"},{"isSystem":null,"itemId":"f7151959-7ad7-4acc-8edf-aea057090ef2","itemName":"French Polynesia"},{"isSystem":null,"itemId":"818d8344-18e0-4893-aac9-5301e819e7a9","itemName":"Gabon"},{"isSystem":null,"itemId":"641c46ce-b33a-49db-852f-d1ddee9e0462","itemName":"Gambia"},{"isSystem":null,"itemId":"287ca271-0c28-4256-aaf3-76c5528cd685","itemName":"Georgia"},{"isSystem":null,"itemId":"646f43b3-ae25-480e-a7ed-2984904b416f","itemName":"Germany"},{"isSystem":null,"itemId":"b7ad43f2-0f0d-444a-967b-b94d220aace8","itemName":"Ghana"},{"isSystem":null,"itemId":"72e197e9-ab5d-4637-8aec-55f2005e2b6a","itemName":"Gibraltar"},{"isSystem":null,"itemId":"4bb18371-00d9-4b43-abd2-873d1ca730b1","itemName":"Greece"},{"isSystem":null,"itemId":"d8aa8178-9c90-48dd-a1fa-0ff82f9d5701","itemName":"Greenland"},{"isSystem":null,"itemId":"73a35b3d-9b55-4f65-b01b-1c4b79ae125e","itemName":"Grenada"},{"isSystem":null,"itemId":"c76483f6-d2f2-4432-bd48-7db19fc995bc","itemName":"Guam"},{"isSystem":null,"itemId":"d0a237c8-ef9e-45b6-bac5-bb224d15a624","itemName":"Guatemala"},{"isSystem":null,"itemId":"f5817c0f-df91-4bfe-b88c-0c1f6c4c959c","itemName":"Guernsey"},{"isSystem":null,"itemId":"45bc08dd-800e-45c1-b2b4-bfc082641846","itemName":"Guinea"},{"isSystem":null,"itemId":"3b7e12c6-e0ba-4f0f-98c1-af037a034003","itemName":"Guinea-Bissau"},{"isSystem":null,"itemId":"a22b71de-1c3e-4da5-a78d-0306ad4a598c","itemName":"Guyana"},{"isSystem":null,"itemId":"77e9523a-22bf-4953-9978-33752e5f74d3","itemName":"Haiti"},{"isSystem":null,"itemId":"e83fc732-0dbf-42db-b684-aaebf88599e0","itemName":"Honduras"},{"isSystem":null,"itemId":"d70a1d2d-37b2-48b8-8ff1-b14e8f6cb131","itemName":"Hong Kong"},{"isSystem":null,"itemId":"f71f54d5-7562-4ba7-9994-789e4fc680d3","itemName":"Hungary"},{"isSystem":null,"itemId":"fadb2942-b5c6-4bc1-8093-9e6351430b71","itemName":"Iceland"},{"isSystem":null,"itemId":"d87bedca-5bcc-4241-8027-7e16f3b68f18","itemName":"India"},{"isSystem":null,"itemId":"7b170b87-5a4a-433b-be4f-de16592cd5fc","itemName":"Indonesia"},{"isSystem":null,"itemId":"efd7b38c-9990-465d-8999-5717293da725","itemName":"Iran"},{"isSystem":null,"itemId":"2fe63ec8-de77-491c-91bb-00af8a4e7156","itemName":"Iraq"},{"isSystem":null,"itemId":"7a57e6a2-0782-4458-b167-943458fcc736","itemName":"Ireland"},{"isSystem":null,"itemId":"b432d405-3358-4339-a4b1-6e85af355068","itemName":"Isle of Man"},{"isSystem":null,"itemId":"f1ed6fb5-6baa-4402-bbd9-52695c0207fb","itemName":"Israel"},{"isSystem":null,"itemId":"4ebda820-b1a9-456b-ad61-4162bab236b2","itemName":"Italy"},{"isSystem":null,"itemId":"f214a6fe-a3bc-4ed9-8703-982e1c37b2d6","itemName":"Ivory Coast"},{"isSystem":null,"itemId":"335e9ef1-b928-4e6e-adf1-0095e1de2b39","itemName":"Jamaica"},{"isSystem":null,"itemId":"4fe63ec6-a3f2-4505-8d04-42fd31589ad0","itemName":"Japan"},{"isSystem":null,"itemId":"93b03d38-80a0-4535-9595-8d07215fb0b9","itemName":"Jersey"},{"isSystem":null,"itemId":"4680ce50-9c41-46bc-89a6-458205888ec3","itemName":"Jordan"},{"isSystem":null,"itemId":"6a7b0321-ac2c-4975-9f48-0243895143a4","itemName":"Kazakhstan"},{"isSystem":null,"itemId":"6c13c144-a2b3-4aea-85f8-5aae8d6a8665","itemName":"Kenya"},{"isSystem":null,"itemId":"4950e27a-b0e6-4fea-abeb-7a9afd702edf","itemName":"Kiribati"},{"isSystem":null,"itemId":"9c8a6493-1d8c-493d-b08e-26c672b84e68","itemName":"Kosovo"},{"isSystem":null,"itemId":"5ccb05f7-9f46-43ff-8724-360b7b452841","itemName":"Kuwait"},{"isSystem":null,"itemId":"4e78685b-7d60-4f3c-8361-c1e14d067e4e","itemName":"Kyrgyzstan"},{"isSystem":null,"itemId":"10946f9b-cfdf-49f4-8d1b-d2ef5e976ab6","itemName":"Laos"},{"isSystem":null,"itemId":"167eb48c-2e24-4587-b7ef-7013c9fa01eb","itemName":"Latvia"},{"isSystem":null,"itemId":"a4465300-98b9-477a-95d9-4feca5234059","itemName":"Lebanon"},{"isSystem":null,"itemId":"ef2f6e35-770e-4ce7-bb10-99d924b9ace8","itemName":"Lesotho"},{"isSystem":null,"itemId":"0eee0d3a-c95f-4d61-8e2e-ece0a2009ac0","itemName":"Liberia"},{"isSystem":null,"itemId":"c03c1992-ea4b-4be2-b01d-d8ace3735b16","itemName":"Libya"},{"isSystem":null,"itemId":"048eb254-34f9-4307-8002-f08b6e7fadc6","itemName":"Liechtenstein"},{"isSystem":null,"itemId":"19a27fdb-5b1f-4f61-b109-00c55ff472d3","itemName":"Lithuania"},{"isSystem":null,"itemId":"ec4be088-d193-40c2-aad7-a4f286f43a28","itemName":"Luxembourg"},{"isSystem":null,"itemId":"3e55a220-b305-4b11-841a-7bbf8214de37","itemName":"Macau"},{"isSystem":null,"itemId":"353d015e-5b2d-47b6-91fd-8cc43db6c34e","itemName":"Macedonia"},{"isSystem":null,"itemId":"26fb72d2-5687-4fbb-b5cf-476663b42332","itemName":"Madagascar"},{"isSystem":null,"itemId":"d37541e3-6799-4758-9964-6652d5de6cbb","itemName":"Malawi"},{"isSystem":null,"itemId":"2f0c6c25-2bab-45cf-80d6-c88d300d3b58","itemName":"Malaysia"},{"isSystem":null,"itemId":"449a6dd0-e81d-4e3e-91a7-bdfd90929282","itemName":"Maldives"},{"isSystem":null,"itemId":"855d6f23-2355-4dc3-afd7-8c125af23a87","itemName":"Mali"},{"isSystem":null,"itemId":"4ce6426b-05d1-4e1d-aa60-064c98f8ccfe","itemName":"Malta"},{"isSystem":null,"itemId":"3b68054d-a14b-47bf-92de-6cb84ddd4683","itemName":"Marshall Islands"},{"isSystem":null,"itemId":"807ca7f8-55c0-459b-a268-f4aa42ffa92b","itemName":"Mauritania"},{"isSystem":null,"itemId":"2877f769-ee8d-4b76-8965-5b319b313568","itemName":"Mauritius"},{"isSystem":null,"itemId":"7d5c3c5b-0347-4f92-a162-8651089e55f6","itemName":"Mayotte"},{"isSystem":null,"itemId":"dda69fd1-ea95-43fc-b55b-0738cc4c3dd2","itemName":"Mexico"},{"isSystem":null,"itemId":"3f5c65b1-7a4d-45e9-bf19-a296c9c05cae","itemName":"Micronesia"},{"isSystem":null,"itemId":"d0dc91d7-fb4b-40b4-801a-2894a7896701","itemName":"Moldova"},{"isSystem":null,"itemId":"1d760f1b-69f6-4768-a027-5268bb387cf6","itemName":"Monaco"},{"isSystem":null,"itemId":"69912626-37a2-4b45-a3f6-d1d2661c9b6e","itemName":"Mongolia"},{"isSystem":null,"itemId":"6f95c022-d6d3-4b68-a9aa-cf8e964bc914","itemName":"Montenegro"},{"isSystem":null,"itemId":"a9eaf012-79e5-4b5b-90d9-42b7ce9e7efc","itemName":"Montserrat"},{"isSystem":null,"itemId":"19b18aaa-b9dd-4c79-abc9-21fd81bd19d5","itemName":"Morocco"},{"isSystem":null,"itemId":"826d6316-f211-45d6-96c9-1739682ceafe","itemName":"Mozambique"},{"isSystem":null,"itemId":"9d0b6179-4bba-4610-b9e2-657d12440fe7","itemName":"Myanmar"},{"isSystem":null,"itemId":"c9f0cdc2-a985-425c-bd23-11c333e80a7a","itemName":"Namibia"},{"isSystem":null,"itemId":"22f77a15-90f1-4f73-92ab-99f140097d61","itemName":"Nauru"},{"isSystem":null,"itemId":"6fd0e17a-e1d1-4dcd-acc0-c664340dd494","itemName":"Nepal"},{"isSystem":null,"itemId":"99ed2dfd-6f3f-4c54-a791-a511d215f4f6","itemName":"Netherlands"},{"isSystem":null,"itemId":"f540c0ea-9aa8-4606-8525-8e2682f3c9cb","itemName":"Netherlands Antilles"},{"isSystem":null,"itemId":"01eb4097-0dea-43d9-97a5-d0352aa9b11c","itemName":"New Caledonia"},{"isSystem":null,"itemId":"2c085683-a72f-40d2-a29a-5449c2ec27b4","itemName":"New Zealand"},{"isSystem":null,"itemId":"89751b98-7fdf-4198-8fd4-cf6052ded652","itemName":"Nicaragua"},{"isSystem":null,"itemId":"a5d10b59-d387-414a-8b09-b19bbced913f","itemName":"Niger"},{"isSystem":null,"itemId":"9a540966-8ed2-48cb-b0d2-0fbcbe75f319","itemName":"Nigeria"},{"isSystem":null,"itemId":"9089669f-c368-4ee1-876c-d28b4cfbafba","itemName":"Niue"},{"isSystem":null,"itemId":"15a68b23-040f-4acf-b001-3992004fcb5f","itemName":"North Korea"},{"isSystem":null,"itemId":"0ec673dd-fb3a-4bd8-ba91-fc2851e50b67","itemName":"Northern Mariana Islands"},{"isSystem":null,"itemId":"46207852-c82d-43be-9fc4-6393fb39a4d3","itemName":"Norway"},{"isSystem":null,"itemId":"b06df373-7c95-46e9-862a-ab1312d426b1","itemName":"Oman"},{"isSystem":null,"itemId":"cc7ac749-e22d-43d5-b343-e11f6f4a67c0","itemName":"Pakistan"},{"isSystem":null,"itemId":"2d3508f7-49fc-4a82-b841-93dc80e307db","itemName":"Palau"},{"isSystem":null,"itemId":"4ca7e9e8-aa4d-4fc5-804e-3258f3160408","itemName":"Palestine"},{"isSystem":null,"itemId":"685b9b89-ef96-4ebb-9dc6-6e5dc7222e89","itemName":"Panama"},{"isSystem":null,"itemId":"bfe74134-db29-4d52-838c-a43a9052efbc","itemName":"Papua New Guinea"},{"isSystem":null,"itemId":"885595d4-f91c-4c01-9d29-e042684d830a","itemName":"Paraguay"},{"isSystem":null,"itemId":"c7e9fe81-1313-4326-a84f-b7f6699ae0ae","itemName":"Peru"},{"isSystem":null,"itemId":"21e69aa8-f30d-41b3-af06-9a6a0bfd0496","itemName":"Philippines"},{"isSystem":null,"itemId":"bba489bb-1048-4b33-a56b-9658ee572065","itemName":"Pitcairn"},{"isSystem":null,"itemId":"a0d43b90-7bf4-425e-98a4-260573aa9692","itemName":"Poland"},{"isSystem":null,"itemId":"ae8f4ff5-3b59-4a6f-b83d-f47db083cf79","itemName":"Portugal"},{"isSystem":null,"itemId":"92d7e1c8-15d3-4de6-a87c-0652e85a5b06","itemName":"Puerto Rico"},{"isSystem":null,"itemId":"ed11850d-9fbf-4ab4-9989-fd12267b41e2","itemName":"Qatar"},{"isSystem":null,"itemId":"840fffd6-122a-46bf-8f37-c28158fb71e9","itemName":"Republic of the Congo"},{"isSystem":null,"itemId":"daf67fee-97db-424e-b383-d71046823400","itemName":"Reunion"},{"isSystem":null,"itemId":"aca10bc2-7bae-48bd-91bb-315827f222ec","itemName":"Romania"},{"isSystem":null,"itemId":"2e3bc12a-776a-41d3-9412-3345a8e32f57","itemName":"Russia"},{"isSystem":null,"itemId":"fd03e131-a9fb-46c2-a9c7-3196920b8138","itemName":"Rwanda"},{"isSystem":null,"itemId":"d27e39bd-9e15-413e-bbb1-7c361eac1dbe","itemName":"Saint Barthelemy"},{"isSystem":null,"itemId":"18a2c655-487f-41ea-a753-f0f1747e3891","itemName":"Saint Helena"},{"isSystem":null,"itemId":"e668e7a5-3186-47a0-bd7d-fcbad7a02c05","itemName":"Saint Kitts and Nevis"},{"isSystem":null,"itemId":"b5845d7d-1fc6-4121-85d8-a52a4da2b695","itemName":"Saint Lucia"},{"isSystem":null,"itemId":"28f40f14-5457-4064-b6f7-9613cb6a97dd","itemName":"Saint Martin"},{"isSystem":null,"itemId":"16b808d2-c625-4715-a679-95fe90b12fb3","itemName":"Saint Pierre and Miquelon"},{"isSystem":null,"itemId":"ee132fc0-912f-446d-8f73-6095b009c7f7","itemName":"Saint Vincent and the Grenadines"},{"isSystem":null,"itemId":"f7c76727-c127-405c-8ac4-c9c3592bc843","itemName":"Samoa"},{"isSystem":null,"itemId":"433a7f02-6506-4b6b-a408-7d71509ee91b","itemName":"San Marino"},{"isSystem":null,"itemId":"5613d5f2-7235-424b-ac78-04772af44364","itemName":"Sao Tome and Principe"},{"isSystem":null,"itemId":"e4f45c0b-9c33-48a8-97de-5c7b3210ecef","itemName":"Saudi Arabia"},{"isSystem":null,"itemId":"c6ab304d-cfba-4b20-9cf1-dff162416aa5","itemName":"Senegal"},{"isSystem":null,"itemId":"8e323f61-f929-4de0-987a-2f3a53339450","itemName":"Serbia"},{"isSystem":null,"itemId":"80fbec3b-0e5b-4826-b619-5abd82dc9a76","itemName":"Seychelles"},{"isSystem":null,"itemId":"cb46c408-1a45-4127-b69e-452b20f74ecb","itemName":"Sierra Leone"},{"isSystem":null,"itemId":"ac0f5d38-c74d-475d-bb96-e5947fe3bb2e","itemName":"Singapore"},{"isSystem":null,"itemId":"7171fd69-a0bc-4a92-bf2c-cd0cdd0307c7","itemName":"Sint Maarten"},{"isSystem":null,"itemId":"235e770b-640b-4eac-911a-6b8a12d1e86f","itemName":"Slovakia"},{"isSystem":null,"itemId":"9f0cd30b-b877-4b6c-8377-4dfb9873fcab","itemName":"Slovenia"},{"isSystem":null,"itemId":"3129908d-8b72-4606-b9ea-7220497c657d","itemName":"Solomon Islands"},{"isSystem":null,"itemId":"666d7881-dc2b-4015-b8e0-b94ae5c9595e","itemName":"Somalia"},{"isSystem":null,"itemId":"962703f6-733e-431e-b868-9a6fc2f4a752","itemName":"South Africa"},{"isSystem":null,"itemId":"19a26c4c-5063-4480-b272-759668251f4b","itemName":"South Korea"},{"isSystem":null,"itemId":"815c9c39-2e86-49ec-8ae3-684949061e69","itemName":"South Sudan"},{"isSystem":null,"itemId":"aceab133-9d61-40bf-87b8-e1872b23016e","itemName":"Spain"},{"isSystem":null,"itemId":"7770bbe2-ef99-47a1-bca4-20c1106e92a6","itemName":"Sri Lanka"},{"isSystem":null,"itemId":"ccf16b9f-993f-424c-9d55-8ec58b3afb83","itemName":"Sudan"},{"isSystem":null,"itemId":"fc814cb7-2972-44a6-bb8f-61855496487b","itemName":"Suriname"},{"isSystem":null,"itemId":"07644c8f-7e64-4e12-a8cb-4d8ad65cf11c","itemName":"Svalbard and Jan Mayen"},{"isSystem":null,"itemId":"bb76418f-350c-427a-985b-d9ab7cd1c6ec","itemName":"Swaziland"},{"isSystem":null,"itemId":"bae8507d-9651-4da0-98a1-d9cd2cf2185a","itemName":"Sweden"},{"isSystem":null,"itemId":"58e38ea3-547d-47d2-86dd-4cbcdc09a5c6","itemName":"Switzerland"},{"isSystem":null,"itemId":"83b87177-9172-4a5f-a2e3-52210b957625","itemName":"Syria"},{"isSystem":null,"itemId":"cbe2454f-3747-4530-ac33-0c4d83325aa9","itemName":"Taiwan"},{"isSystem":null,"itemId":"7ba2c969-d5bc-4418-82e6-af0c48cec11e","itemName":"Tajikistan"},{"isSystem":null,"itemId":"41d9a710-5e2d-456b-ab53-dad3a97086bf","itemName":"Tanzania"},{"isSystem":null,"itemId":"b284dd82-0a24-488f-80fa-5dc4e1cd5edd","itemName":"Thailand"},{"isSystem":null,"itemId":"5c9d9e2e-9ca4-476e-919e-1ef0ce51b8b4","itemName":"Togo"},{"isSystem":null,"itemId":"f0c1ba56-32d5-4965-a577-500737a02ad0","itemName":"Tokelau"},{"isSystem":null,"itemId":"8ad69ebe-3cc4-475f-997c-033b69dc7f26","itemName":"Tonga"},{"isSystem":null,"itemId":"ef3c93d2-44d0-40fe-9a24-83e9c968d5b9","itemName":"Trinidad and Tobago"},{"isSystem":null,"itemId":"20910e4c-2e9c-4373-b34b-2cdfa77d2ed6","itemName":"Tunisia"},{"isSystem":null,"itemId":"876e2a06-6f70-48a9-86ab-c143e8704878","itemName":"Turkey"},{"isSystem":null,"itemId":"b47779e5-9b6f-48c4-a043-666193a22116","itemName":"Turkmenistan"},{"isSystem":null,"itemId":"6c5d65f8-74ad-4d69-8edc-d5f8249e52d9","itemName":"Turks and Caicos Islands"},{"isSystem":null,"itemId":"b4152626-ee38-4481-bc88-668440a16dcd","itemName":"Tuvalu"},{"isSystem":null,"itemId":"0194e7c3-1687-4f6d-911f-ad8a3d15c916","itemName":"U.S. Virgin Islands"},{"isSystem":null,"itemId":"ec7109bf-4520-412a-b77b-6531c51e5bb8","itemName":"Uganda"},{"isSystem":null,"itemId":"de471141-44b5-42fa-a388-13355b24beb5","itemName":"Ukraine"},{"isSystem":null,"itemId":"17cfe901-324c-46b4-8abc-2fcc4e3523e4","itemName":"United Arab Emirates"},{"isSystem":null,"itemId":"f38505dd-6400-4b21-bac4-18e858b2252e","itemName":"United Kingdom"},{"isSystem":null,"itemId":"68236cd9-a481-4f1c-90e3-27ad34b216bc","itemName":"United States"},{"isSystem":null,"itemId":"f8214e90-fd3b-48d8-b849-30f5d544bc73","itemName":"Uruguay"},{"isSystem":null,"itemId":"bf070c65-3cce-45e0-8f4e-4ca1584dd350","itemName":"Uzbekistan"},{"isSystem":null,"itemId":"1b1af8be-901c-4d0f-bafc-d590ef8067ae","itemName":"Vanuatu"},{"isSystem":null,"itemId":"dfa7cc28-3916-4045-847c-f3078a47e35b","itemName":"Vatican"},{"isSystem":null,"itemId":"261b261c-fc08-496d-b6c0-47210a8726bc","itemName":"Venezuela"},{"isSystem":null,"itemId":"186509a1-34f0-4c9b-ab1b-525d7d93e6d6","itemName":"Vietnam"},{"isSystem":null,"itemId":"51f94f1e-e7bd-439e-a8fd-3bdb975032fb","itemName":"Wallis and Futuna"},{"isSystem":null,"itemId":"58fd727b-124a-4702-bd90-79be2b8e4084","itemName":"Western Sahara"},{"isSystem":null,"itemId":"f210b96e-4813-4444-9d0b-8faf00fbd2db","itemName":"Yemen"},{"isSystem":null,"itemId":"b3b2398f-cceb-4bf8-80a1-f54933a50a4e","itemName":"Zambia"},{"isSystem":null,"itemId":"eb2666b6-e1ed-4ab5-9348-02cdd42924ee","itemName":"Zimbabwe"}],
            dialogRealtime:false,
            driveAlert:false,
            backupAlert:false,
            lastBackupDate:null
        }
    },

    watch: {
        // whenever uniqueIds changes, this function will run
        uniqueIds() {
          if(this.uniqueIds.length<50){
            this.fn_generateUniqueIds();
          }
        }
    },

    methods:{

        // fn_deletedb: function(){
        //     let dataTransactionRef = require('./data_transaction.js').dataTransaction;
        //     dataTransactionRef.fn_deleteDatabase(this);
        // },

        // for quantity 8 digits and 3 decimals
        fn_boundDecimalLength: function(obj, key, item, inputfn){
            // this.$nextTick(() => {
                let decimalIndex = obj[key].indexOf('.');
                let intVal = null;
                if(decimalIndex != -1){
                    intVal = obj[key].substr(0, obj[key].indexOf('.'));
                }
                else{
                    intVal = obj[key];
                }
                let intValue = intVal.length > 8 ? intVal.slice(0, 8) : intVal;
                if(obj[key].indexOf('.') != -1){
                    let decVal = obj[key].substr(obj[key].indexOf('.')+1);
                    let decimalValue = decVal.slice(0, 3);
                    obj[key] = intValue ? intValue + '.' + decimalValue : '.' + decimalValue;
                }
                else{
                    obj[key] = intValue;
                }
                inputfn ? inputfn(item) : '';
            // })
        },

        // only for 2 decimals
        fn_boundDecimalLengthUpto2: function(obj, key){
            this.$nextTick(() => {
                let decimalIndex = obj[key].indexOf('.');
                if(decimalIndex != -1){
                    let intVal = obj[key].split('.')[0];
                    let decVal = obj[key].split('.')[1];
                    obj[key] = intVal + '.' + decVal.slice(0, 2);
                }
            })
        },

        fn_generateUniqueIds: function(callback){
            let counter = 500;
            let uniqueIds = [];
            for(let i=0; i<counter; i++){
                uniqueIds.push(this.guidWeb());
            }

            // this.uniqueIds = uniqueIds;
            this.uniqueIds = this.uniqueIds.concat(uniqueIds);

            let filterObject = {};
            filterObject.uniqueIds = uniqueIds;
            let self = this;
            this.getFilterData('ValidateUniqueIds', this.CurrentBusiness.BusinessID, filterObject, null, {
                onSuccess: function(response){
                    // console.log(response);
                    let duplicates = JSON.parse(response);
                    if(duplicates && duplicates.length){
                        for(let i=0; i<duplicates.length; i++){
                            let itemIndex = self.uniqueIds.findIndex(id=>id == duplicates[i].uniqueId);
                            itemIndex != -1 ? self.uniqueIds.splice(itemIndex, 1) : '';
                        }
                    }

                    callback ? callback() : '';
                }, 
                onError: function(error){
                    console.log(error);
                    callback ? callback('error') : '';
                }
            });
        },

        fn_dialogReconnect: function(val){
            // this.reconnectObj.isTimeOut = false;
            this.connectionNumber = null;
            this.isOfferCreated = false;

            // if(type == 'show_reconnect_dialog'){
            //     this.dialog_reconnect = val;
            // }

            this.reconnectObj.isConnecting = false;
            this.reconnectObj.isDisconnected = false;

            this.reconnectObj.isDialogOpen = val;
            
            this.dialog_reconnect = val;

            // reset reconncect dialog if offer not created within 15 seconds
            // setTimeout(() => {
            //     if(val && !this.isOfferCreated && this.$root.reconnectObj.isConnecting){
            //         this.reconnectObj.isConnecting = false;
            //         this.reconnectObj.isDisconnected = false;
            //         this.$eventHub.$emit('snackbarAlert', {msg:'Connection timeout! Please try again'});
            //         this.fn_closeConnection(false, 'prevent_logout', null, true);
            //     }
            // }, 1 * 15 * 1000);
            
        },

        fn_states: function(val){
          let filterObject = {};
          filterObject.search = val ? val.toLowerCase() : '';
          
          let self = this;
          this.getDialogItems("StateDialog", filterObject, 
            {
              onSuccess: function (response) {
                console.log(response);
                self.states = JSON.parse(response);
              },
              onError: function (error) {
                console.log(error);
              }
            }
          )
        },

        fn_getActionPaneWidth: function(){
            if(document.getElementsByClassName("action_pane") && document.getElementsByClassName("action_pane").length){
                return document.getElementsByClassName("action_pane")[0].offsetWidth;
            }
            else{
                return 'auto';
            }
        },

        fn_getLayoutWidth: function(){
            if(document.getElementsByClassName("right_layout") && document.getElementsByClassName("right_layout").length){
                return document.getElementsByClassName("right_layout")[0].offsetWidth;    
            }
            else{
                return 'auto';
            }
        },

        fn_getBusiness: function(path, businessStatusOld, callback, doNotCallSettings){
            let self = this;
            // let businessDetails = false;

            // setTimeout(() => {
            //     if(!businessDetails){
            //         this.fn_getBusiness(path, businessStatusOld, callback);
            //     }
            // }, 1000 * 1 * 10);

            // let notRespondTimeout = setTimeout(() => {
            //     if(!businessDetails){
            //         // alert("Trying to reconnect as server device is not responding!");
            //         clearTimeout(notRespondTimeout);
            //         // alert('in');
            //         this.$eventHub.$emit('snackbarAlert', {msg:'Unable to connect as business mobile device is not responding!'});
            //         // this.fn_dialogReconnect(true);
            //         this.fn_closeConnection(true, null, 1);
            //     }
            // }, 1000 * 10 * 10);

            this.getData('AllBusiness', null, {
                onSuccess: function(response){
                    console.log(response);
                    
                    let data  = JSON.parse(response);

                    // businessDetails = true;

                    if(data.activeConnections > 2){
                        // self.$eventHub.$emit('snackbarAlert', {msg:'This business already have reached to its maximum connections!'});
                        // self.fn_closeConnection(false, 'prevent_logout', 1, true);
                        // if(self.CurrentBusiness){
                            // self.fn_dialogReconnect(true);
                        // }
                        self.fn_removeExtraClient(data.currentBusiness.BusinessID);
                        // return;
                    }

                    if(data){
                        self.CurrentBusiness = data.currentBusiness;
                        self.Businesses.BusinessList = data.businessList;
                        self.Businesses.BusinessCount = data.businessCount;
                        // data.openingDate ? self.fn_assignMinDateSelection(data.openingDate) : '';
                        self.fn_setMinTransactionDate();

                        if(businessStatusOld && businessStatusOld != self.CurrentBusiness.GSTRegistrationStatus){
                            self.fn_updateTtf();
                        }

                        !doNotCallSettings ? self.fn_getTransactionSettings() : '';

                        
                        if(path=='actions'){
                            callback ? callback() : self.$router.replace('/actions');
                        }
                        else if(path=='goback'){
                          self.$router.go(-1);
                        }
                        else{
                            callback ? callback(data.activeConnections) : '';
                        }
                        
                    }
                    else{
                        console.log('Unable to load business');
                        // self.showToast('Something went wrong. Try again');
                    }
                },
                onError: function(error){
                    console.log(error);
                }
            });
        },

        // fn_getCheckPlayStoreUpdate : function(reloadApp, callback){
        fn_getCheckPlayStoreUpdate : function(callback){
            let self = this;
            this.getData('CheckPlayStoreUpdate', null, 
                {
                    onSuccess: function(response){
                        console.log(response);

                        // getting app version saved in android local cache
                        // self.$root.fn_getLocalData('app_version', response=>{
                        //     self.appVersion = response;
                        // });

                        // getting android version directly from android function
                        self.fn_getAndroidAppVer();

                        if(callback){
                            callback(response);
                        }
                        else{
                            if(JSON.parse(response)){
                                self.$eventHub.$emit('UpdateMobileApp', {onload:1});
                            }
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getUserType : function(){
            this.getData('UserType', null, 
                {
                  onSuccess: function(response){
                      console.log(response);
                  }, 
                  onError: function(error){
                      console.log(error);
                  }
                }
            );
        },

        fn_updateTtf: function(callback){
            let postObj = {};
            postObj.transactionTypeId = ["10003"];
            postObj.transactionTypeForms = [];
            if(this.CurrentBusiness.GSTRegistrationStatus==1){
                // postObj.transactionTypeForms = [];
                postObj.title = 'Tax Invoice';

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"ITC Not Eligible", "title":"ITC Not Eligible"};
                for(let i=0; i<defaultData.defaultDataJson.transactionsType.length; i++){
                    let obj = {};
                    obj.transactionTypeFormId = defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId;
                    obj.taxMode = defaultData.defaultDataJson.transactionsType[i].taxMode;

                    if(defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId == configs.statusUpdate.transactionTypeForm.expense.id){
                        // obj.name = "ITC Not Eligible";
                        // obj.title = "ITC Not Eligible";
                        obj.name = "Expense";
                        obj.title = "Expense";
                    }
                    postObj.transactionTypeForms.push(obj);
                }

                this.fn_updateTtfRegister(callback, postObj)
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==2){
                postObj.title = 'Bill of Supply';
                postObj.taxMode = 0;

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":"Composition Taxable Person"});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"Expense", "title":"Expense"};
                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==3){
                postObj.title = 'Invoice';
                postObj.taxMode = 0;

                // postObj.fieldId = "5b9dcbb4-697f-4115-ac86-79c3cb064617";
                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                // postObj.transactionType = {"id":configs.statusUpdate.transactionTypeForm.expense.id, "name":"Expense", "title":"Expense"};
                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
        },

        fn_updateTtfRegister: function(callback, postObj){
            console.log(JSON.stringify(postObj));
            this.postFilterData('UpdateTtfToRegister', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateTtfOther: function(callback, postObj){
            this.postFilterData('UpdateTtfToOther', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_setMinTransactionDate: function(){
            let year = this.$moment(this.CurrentBusiness.OpeningDate).format('YYYY');
            let month = this.$moment(this.CurrentBusiness.OpeningDate).format('MM');
            let day = this.$moment(this.CurrentBusiness.OpeningDate).format('DD');

            this.minDateSelection = year+"-"+month+"-"+day;
        },

        fn_setUploadStatus: function(status){
            this.uploadStatus = status;
        },

        fn_getGstType: function(partyStateId, partyGstType, importExport){
            if(this.CurrentBusiness.StateID){
            
                let ut = false;

                for(let i=0; i<unionTerritoryStates.length; i++){
                    if((unionTerritoryStates[i].id == this.CurrentBusiness.StateID) && (partyStateId == this.CurrentBusiness.StateID)){
                        ut = true;
                        break;
                    }
                }

                if(ut && !importExport)
                    return "UnionTerritory"

                else if(partyStateId == this.CurrentBusiness.StateID && (partyGstType!=configs.accountGstType.overseas.id && partyGstType!=configs.accountGstType.sez.id))
                    return "IntraState"

                else
                    return "InterState"
            }
              
            return null;
        },

        fn_getTransactionSettings: function(callback){
            let self = this;
            this.getData('TransactionSettings', this.CurrentBusiness.BusinessID, 
              {
                onSuccess: function(response){
                    console.log(response);
                    response!='null' ? self.TransactionSettings = JSON.parse(response) : '';
                    !self.TransactionSettings.businessId ? self.TransactionSettings.businessId = self.CurrentBusiness.BusinessID : '';

                    if(self.TransactionSettings && self.TransactionSettings.additionalData){
                        self.TransactionSettings = JSON.parse(self.TransactionSettings.additionalData);
                    }

                    // patch for type wise number series
                    let data = JSON.parse(response);
                    if(data.typeWiseNumberSeries != undefined){
                        self.TransactionSettings.typeWiseNumberSeries = data.typeWiseNumberSeries;
                    }
                
                    callback ? callback() : '';
                    self.fn_getBusinessLogo();
                },
                onError: function(error){
                    console.log(error);
                }
              }
            );
        },

        fn_getBusinessLogo: function(){
            let self = this;
            this.getData('BusinessLogo', this.CurrentBusiness.BusinessID, 
              {
                onSuccess: function(response){
                    console.log(response);
                    console.log('get logo');
                    self.CurrentBusiness.businessLogo = response;
                },
                onError: function(error){
                    console.log(error);
                }
              }
            );
        },

        fn_getCurrentDateTimeString: function(){
            let isoDateString = new Date().toISOString();
            let date = isoDateString.substring(0, isoDateString.indexOf('T')).replace(/-/g,'');
            let localTimeString = new Date().toLocaleTimeString().replace(/:/g,'');
            let time = localTimeString.substring(0, localTimeString.indexOf(' '));
            let milliSeconds = new Date().getMilliseconds();
            return date + time + milliSeconds;
        },

        fn_getLocalDateFormat: function(dateObj){
            let now = dateObj ? new Date(dateObj) : new Date();
            let year = now.getFullYear();
            let month = ("0" + (now.getMonth()+1)).slice(-2);
            let date = ("0" + now.getDate()).slice(-2);
            let time = now.toTimeString().substring(0, now.toTimeString().indexOf(' '));
            return year + '-' + month + '-' + date + 'T' + time + '.' + now.getMilliseconds();
        },

        numberToLocale: function(value, withoutDecimal){
            // return value ? value.toLocaleString("hi-IN") : 0;
            let indianFormatValue = value ? value.toLocaleString("hi-IN") : 0;
            if(indianFormatValue){
                if(indianFormatValue.split('.').length == 1){
                    return withoutDecimal ? indianFormatValue : indianFormatValue + '.00';
                }
                else{
                    if(indianFormatValue.split('.')[1].length == 1){
                       return indianFormatValue + "0";
                    }
                    else{
                       return indianFormatValue;
                    }
                }
            }
            else{
               return indianFormatValue;
            }
        },

        fixed2Decimal: function(value){
            return value ? value.toFixed(2) : 0;
        },

        fn_abbreviatedBusinessName: function(){
            // let words = this.CurrentBusiness.BusinessName.trim().split(' ');
            // trimming spaces from start and end
            let words = this.CurrentBusiness.BusinessName.trim();
            // trimming spaces from middle if any
            words = words.replace(/ +(?= )/g,'').split(' ');
            // words = words.replace(/ +(?= )/g,'');

            if(words.length > 1){
                return words[0][0].toUpperCase() + words[1][0].toUpperCase();    
            }
            else{
                return words[0][0].toUpperCase();
            }
            
        },

        fn_payOrReceive: function(type, groupTypeId){
            if(groupTypeId==103){
                return type == 1 ? 'Positive' : 'Negative';
            }
            else{
                return type == 1 ? 'To Receive' : 'To Pay';
            }
        },

        isObject(object) {
          return object != null && typeof object === 'object';
        },

        fn_copyFormObject: function(formObj, formId){
            if(!localStorage.getItem(formId)){
                localStorage.setItem(formId, JSON.stringify(formObj));
            }
        },

        fn_getFormObject: function(formId){
            return localStorage.getItem(formId);
        },

        fn_deleteFormObject: function(formId){
            localStorage.removeItem(formId);
        },

        fn_getAuthToken: function(callback){
            if(!navigator.onLine){
                // alert('Internet not available');
                this.$eventHub.$emit('snackbarAlert', {msg:'Internet not available'});
                // this.snackbarAlert = true;
                // this.snackbarAlertMessage = "Internet not available";
                callback('error');
                return;
            }
            
            let self = this;
            this.getData('GetToken', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                        // alert("Something went wrong. Try again!.");
                        self.$eventHub.$emit('snackbarAlert', {msg:'Something went wrong. Try again'});
                        // this.snackbarAlert = true;
                        // this.snackbarAlertMessage = "Something went wrong. Try again";
                        callback('error');
                        // self.hideLoading();
                    }
                }
            );
        },

        fn_getCustomToken: function(){
            this.fn_getAuthToken(token=>{
                var headersObj = {
                    headers: { 
                        'Authorization': 'bearer '+token,
                    }
                };
                // axios.get(this.baseApiUrl + '/api/business/'+this.CurrentBusiness.BusinessID+'/getbusinessusertoken', headersObj, {timeout:30000})
                axios.get(this.$root.baseApiUrl + '/api/user/getbusinesstoken?businessid='+this.CurrentBusiness.BusinessID, headersObj, {timeout:30000})
                .then(response => { 
                    console.log(JSON.stringify(response));
                    document.getElementById('iframe_customer_support').contentWindow.postMessage({
                        type:"token",
                        authToken:response.data.Token
                    }, '*');
                }).catch(e => {
                    console.log(e);
                })
            });
        },

        fn_navigateToNew: function(routePath, routeQuery, formType){
            if(this.$route.path == routePath){
                this.fn_broadcastNavigation(routeQuery, formType);
            }
            else{
                this.$route.query.type != routeQuery.type ? localStorage.setItem('fromFormView', 1) : ''; 
                this.$router.replace({path:routePath, query:routeQuery}).catch(error => {
                    if (error.name === "NavigationDuplicated") {
                        this.fn_broadcastNavigation(routeQuery, formType);
                    }
                });
            }
        },

        fn_broadcastNavigation: function(routeQuery, formType){
            let broadCastFired = false;
            if(!broadCastFired){
                if(formType == 'transaction'){
                    let dataObj = {type:routeQuery.type};
                    this.$eventHub.$emit('newTransaction', dataObj);
                }
                else{
                    this.$eventHub.$emit(routeQuery.type);
                }
            }
            setTimeout(() => {broadCastFired=false}, 500);
        },

        fn_sendBusinessLogoToSupport: function(){
            document.getElementById('iframe_customer_support').contentWindow.postMessage({
                type:"business_logo",
                businessLogo:this.CurrentBusiness.businessLogo
            }, '*');
        },

        fn_getConnectionMsg: function(){
            if(localStorage.getItem('login_type') && localStorage.getItem('login_type') == 'client'){
                return 'Ask client to go "More > Connection Requests" in mobile app, search for '+ this.connectionNumber +' and press connect'
            }
            else{
                return 'Go to "More > Connection Requests" in mobile app, search for '+ this.connectionNumber +' and press connect'
            }
        },

        // getting ice servers from twilio
        fn_getTwilioIceServers: function(callback){

            if(document.cookie){
                let ser = document.cookie;
                // if(ser.substring(0, ser.indexOf('=')) == 'iceservers'){
                // if(ser.indexOf('iceservers') != -1){
                if(ser.indexOf('iceservers_cloud') != -1){
                    try{
                        let iceServers = JSON.parse(ser.substring(ser.indexOf('['), ser.indexOf(']') + 1));
                        return callback(iceServers);
                    }
                    catch(e){
                        console.log(e);
                    }
                }
            }

            this.getFirebaseToken(token=>{
                if(token=="error"){
                    this.$eventHub.$emit('snackbarAlert', {msg:'Something went wrong!'});
                    callback('error');
                    return;
                }

                var headersObj = {
                    headers: { 
                        'Authorization': 'bearer '+token,
                    }
                };

                axios.get(this.baseApiUrl + '/api/desktop/webrtc/gettoken', headersObj, {timeout:30000})
                .then(response => {
                    console.log(JSON.stringify(response.data));

                    // let iceServers = response.data.ice_servers.filter(item=>{
                    //     // return item.url.indexOf('stun:stun') === -1 && item.urls.indexOf('stun:stun') === -1;
                    //     return item.userName;
                    // })

                    // console.log(JSON.stringify(iceServers));
                    
                    // let ed = new Date(response.data.ExpiryDate);
                    let dateTimeNow = new Date();
                    let ed = new Date(dateTimeNow.setHours(dateTimeNow.getHours()+12, dateTimeNow.getMinutes(), 0, 0));
                    var expires = "expires=" + ed.toGMTString();
                    // document.cookie = "iceservers=" + JSON.stringify(response.data.ice_servers) + ";" + expires + ";path=/";
                    document.cookie = "iceservers_cloud=" + JSON.stringify(response.data.ice_servers) + ";" + expires + ";path=/";

                    callback(response.data.ice_servers);
                }).catch(e => {
                    callback('error');
                    this.reconnectObj.isConnecting = false;
                    this.reconnectObj.isReconnecting = false;
                    console.log(e);
                })
            })
        },

        fn_getMinSelectionDate: function(){
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;

            let minDate = new Date(this.minDateSelection);

            if(currentDate > minDate){
            //   if(currentDate.getFullYear() >= minDate.getFullYear() && currentMonth>3){
            //     return new Date(currentDate.getFullYear()+"/04/01");
            //   }
              if(currentDate.getFullYear() >= minDate.getFullYear()){
                if(currentMonth>3){
                    return new Date(currentDate.getFullYear()+"/04/01");
                }
                else{
                    return new Date((currentDate.getFullYear()-1)+"/04/01");
                }
              }
              else{
                // if(minDate.getMonth() + 1 <= 3){
                if(minDate.getFullYear() < currentDate.getFullYear() && (minDate.getMonth() + 1) <= 3){
                    return new Date(minDate.getFullYear()+"/04/01");
                }
                else{
                    return new Date(this.minDateSelection);
                }
                // return new Date(this.minDateSelection);
              }
            }
            else{
              return new Date(this.minDateSelection);
            }
        },

        fn_getMasterItems: function(type, listNames, isGetAll, showLoader){

            if(this.appVersion < 117){
                return;
            }
            
            let filterObject = {};
            filterObject.listName = listNames;
            filterObject.counter = 0;

            showLoader ? this.dialogLoader = true : '';
            let dataTransactionRef = require('./data_transaction.js').dataTransaction;

            console.log('fn_getMasterItems');

            if(type == 'products'){

                console.log('fn_getMasterItems products');

                // if(localStorage.getItem(this.CurrentBusiness.BusinessID+'_ls_item_counter')){
                //     let localObj = JSON.parse(localStorage.getItem(this.CurrentBusiness.BusinessID+'_ls_item_counter'));
                //     filterObject.counter = localObj.counter ? localObj.counter : 0;
                // }

                if(!this.products.length){
                    dataTransactionRef.fn_getMasterItemsFromDB(this, type, listNames, isGetAll, filterObject);
                }
                else{
                    dataTransactionRef.fn_getMasterData(this, type, listNames, isGetAll, filterObject);
                }
            }

            if(type == 'ledgers'){
                
                console.log('fn_getMasterItems ledgers');

                // if(localStorage.getItem(this.CurrentBusiness.BusinessID+'_ls_ledger_counter')){
                //     let localObj = JSON.parse(localStorage.getItem(this.CurrentBusiness.BusinessID+'_ls_ledger_counter'));
                //     filterObject.counter = localObj.counter ? localObj.counter : 0;
                // }

                if(!this.ledgers.length){
                    dataTransactionRef.fn_getMasterItemsFromDB(this, type, listNames, isGetAll, filterObject);
                }
                else{
                    dataTransactionRef.fn_getMasterData(this, type, listNames, isGetAll, filterObject);
                }
            }
        },

        fn_resetCache: function(){
            // this.cacheRetry = false;
            // setTimeout(() => {
            //     if(this.$root.dialogLoader){
            //         this.cacheRetry = true;
            //     }
            // }, 1 * 15 * 1000);
            let dataTransactionRef = require('./data_transaction.js').dataTransaction;
            dataTransactionRef.fn_deleteDatabase(this.$root);
        },

        fn_saveLocalData: function(dataObj){
            this.postData("LocalData", dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getLocalData: function(key, callback){
            this.getData("LocalData", key, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback(response) : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // saving to table
        fn_saveLocalItem: function(dataObj, callback){
            this.postData("LocalItem", dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // getting from table
        fn_getLocalItem: function(key, callback){
            this.getData("LocalItem", key, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback(response) : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_postMetrics: function(postObj){
            postObj.eventName = postObj.eventName.replaceAll(" ", "_");
            this.postData("FirebaseAnalyticEvent", postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getAndroidAppVer: function(callback){
            let self = this;
            this.getData('AndroidAppVersion', null, 
            {
                  onSuccess: function(response){
                    console.log(response);
                    self.appVersion = Number(response);
                    callback ? callback() : '';
                  }, 
                  onError: function(error){
                    console.log(error);
                  }
            });
        },

        customItemFilter(item, queryText) {
            return (
              item.itemName.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
                -1 ||
                item.productCode && item.productCode.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
            );
        },

        fn_initConnectionRequest: function(){
            if(!navigator.onLine){
                this.$eventHub.$emit('snackbarAlert', {msg:"Internet not available"});
                return;
            }
    
            this.getUser(userId=>{
    
                if(userId){
                    this.reconnectObj.isConnecting = true;
                    this.reconnectObj.isReconnecting = true;
                    let businessData = JSON.parse(JSON.stringify(this.CurrentBusiness));
                    businessData.IsTemporary = this.CurrentBusiness && this.CurrentBusiness.temporaryBusiness ? true : false;
                    if(this.CurrentBusiness && this.CurrentBusiness.temporaryBusiness){
                        businessData.BusinessID = this.mainBusinessID;
                        businessData.TempBusinessID = this.CurrentBusiness.BusinessID;
                    }
                    else{
                        businessData.TempBusinessID = null;
                    }
    
                    businessData.type = localStorage.getItem('login_type');
                    // businessData.TempBusinessID = this.$root.CurrentBusiness.temporaryBusiness ? this.$root.CurrentBusiness.BusinessID : null;
                    this.fn_getTwilioIceServers(response => {
                        if(response == 'error'){
                            this.$eventHub.$emit('snackbarAlert', {msg:'Something went wrong. Please try again'});
                            // this.logout();
                            return;
                        }
    
                        this.fn_checkDeviceStatus(businessData, null, null, userId, null, this.reconnectObj, null, response);
                    });
                    
                }
                else{
                    this.$eventHub.$emit('snackbarAlert', {msg:'You have been logged out!'});
                    this.fn_navigate('/login');
                }
            })
        },

        fn_getFormNameByListId: function(listId){
            if(listId == 10001 || listId == 10002 || listId == 10003 || listId == 10004 || listId == 10005){
                return 'Sale'
            }
            else if(listId == 20001 || listId == 20002 || listId == 20003 || listId == 20004){
                return 'Purchase'
            }
            else if(listId == 30001){
                return 'Receipt'
            }
            else if(listId == 30002){
                return 'Payment'
            }
        },

        fn_getCreditLabel: function(){
            if(this.TransactionSettings.ledgerCreditDebitLabelType == 2){
                return 'Credit';
            }
            else{
                return 'To Receive';
            }
        },
        
        fn_getDebitLabel: function(){
            if(this.TransactionSettings.ledgerCreditDebitLabelType == 2){
                return 'Debit';
            }
            else{
                return 'To Pay';
            }
        },

        fn_removeExtraClient: function(businessId){
            this.getData('RemoveOtherExtraClient', businessId, 
                {
                  onSuccess: function(response){
                      console.log(response);
                  }, 
                  onError: function(error){
                      console.log(error);
                  }
                }
            );
        },

        fn_getLastBackupInfo: function(){
            let self = this;
            this.getData('BackupTime', this.$root.CurrentBusiness.BusinessID, 
                {
                    onSuccess: function(response){
                        console.log(response);

                        let l_date = JSON.parse(response);
                        let lastBackupBefore = null;

                        if(l_date){
                            self.lastBackupDate = new Date(l_date);
                            let dateNow = new Date();
                            lastBackupBefore = parseInt((dateNow - self.lastBackupDate) / (1000 * 60 * 60 * 24), 10); 
                        }
                        else{
                            self.lastBackupDate = null;
                        }

                        if(!self.lastBackupDate || lastBackupBefore >= 4){
                            self.backupAlert = true;
                        }
                        else{
                            self.backupAlert = false;
                            self.$eventHub.$emit('snackbarAlert', {msg:'Data backup complete.'});
                        }

                    }, 
                    onError: function(error){
                        console.log(error);
                    }, 
                }
            );
        },

        fn_settingUpPrintPageSize: function(){
            let style = document.createElement('style');
            style.id = 'dynamic-page-size';

            style.innerHTML = `
                @page {
                    size: A4;
                    margin: 0.5cm 1cm;
                }
            `;

            document.head.appendChild(style);

            setTimeout(() => {
                // Remove old style if exists
                const old = document.getElementById('dynamic-page-size');
                if (old) old.remove();
            }, 1000);
        }
    },
    computed:{
        batchDateFormat: function(){
            if(this.TransactionSettings.hideMfgExpDay){
                return "MMM-YYYY";
            }
            else{
                return "DD-MMM-YYYY";
            }
        }
    },
    mounted: function(){

        this.$eventHub.$on('dialog_realtime', ()=>{
            !this.dialogRealtime ? this.dialogRealtime = true : '';
        });

        this.$eventHub.$on('snackbarAlert', obj=>{
            this.$root.snackbarMessage = obj.msg;
            this.$root.snackbarIsVertical = obj.isVertical ? true : false;
            this.$root.snackbarTimeout = obj.timeout ? obj.timeout : 5000;
            this.$root.snackbar = true;
        });

        this.$eventHub.$on('hideSnackbarAlert', ()=>{
            this.$root.snackbar = false;
        });

        this.$eventHub.$on('offercreated', ()=>{
            this.isOfferCreated = true;
        });

        this.$eventHub.$on('requestFailed', ()=>{
            this.infoDrawer = true;
        });

        let isCalled = false;
        this.$eventHub.$on('GetMasterItems', obj=>{
            if(!isCalled){
                isCalled = true;
                let type = null;
                let listNames = null;
                if(obj.type == 'Product'){
                    type = 'products';
                    listNames = ["Product", "deleteProductWithOpening"];
                }
                else if(obj.type == 'Ledger'){
                    type = 'ledgers';
                    listNames = ["Ledger", "deleteAccountWithOpening"];
                }
                
                this.fn_getMasterItems(type, listNames);

                setTimeout(() => {
                    isCalled = false;
                }, 1000);
            }

        });


        // updating product status when updating thru mobile
        let isUpdateCalled = false;
        this.$eventHub.$on('ProductStatusUpdate', obj=>{
            if(!isUpdateCalled){
                isUpdateCalled = true;
                setTimeout(() => {
                    isUpdateCalled = false;
                }, 1000);
                let itemIndex = this.products.findIndex(item=>{return item.itemId == obj.productId});
                this.products[itemIndex].status = obj.status;
                let dataTransactionRef = require('./data_transaction.js').dataTransaction;
                dataTransactionRef.fn_updateItem(this, obj.productId, obj.status);
            }
        });

        window.addEventListener("offline", (event) => {
            console.log(event);
            this.offline = true;
            // alert('offline');
        });

        window.addEventListener("online", (event) => {
            console.log(event);
            this.offline = false;
            // alert('online');
        });

        window.addEventListener("message", (event) => {
            console.log(event);
            if(event.data.type == "getToken"){
                this.fn_getCustomToken();
            }

            if(event.data.type == "closeSupportApp"){
                this.dialog_customer_support = false
            }

            if(event.data.type == "getBusinessLogo"){
                this.fn_sendBusinessLogoToSupport();
            }
            // alert('online');
        });

        document.addEventListener("contextmenu", function (e){
            e.preventDefault();
        }, false);

        let eventFired = false;

        window.addEventListener('keydown', (event) => {
            console.log(event);
            
            setTimeout(() => {
                eventFired = false;
                this.viaKeyboardShortCut = false;
            }, 1000);

            if (event.ctrlKey && event.code === 'KeyR') {
                event.preventDefault();
            }

            if(!eventFired && this.$root.CurrentBusiness){
                // Display view actions
                if (event.ctrlKey && event.code === 'Delete') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('delete');
                }
                else if (event.ctrlKey && event.code === 'KeyE') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('edit');
                }
                else if (event.ctrlKey && event.code === 'KeyX') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('cancel');
                }
                // Form actions
                else if (event.ctrlKey && event.code === 'KeyS') {
                    // to prevent that discard dialog should not appear when saving form
                    this.viaKeyboardShortCut = false;
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('save');
                }
                else if(event.shiftKey && event.code === 'KeyL' && document.activeElement.type !== 'textarea' && document.activeElement.type !== 'text'){
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('select_party');
                }
                else if(event.shiftKey && event.code === 'KeyM' && document.activeElement.type !== 'textarea' && document.activeElement.type !== 'text'){
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('select_item');
                }
                // invoice actions
                else if (event.ctrlKey && event.code === 'KeyD') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('download');
                }
                // else if (event.ctrlKey && event.code === 'KeyP') {
                //     event.preventDefault();
                //     eventFired = true;
                //     this.viaKeyboardShortCut = true;
                //     this.$eventHub.$emit('print');
                // }
                else if (event.key == 'Escape' && event.code === 'Escape') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    this.$eventHub.$emit('escape');
                }
                // Navigations
                else if (event.altKey && event.code === 'KeyS') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'saleinvoice'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyR') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'salereturn'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyQ') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'estimate'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyP') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'purchaseinvoice'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyD') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'purchasereturn'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyE') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'expense'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyI') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'receipt'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyO') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/transactions";
                    let query = {type:'payment'}
                    this.fn_navigateToNew(path, query, 'transaction');
                }
                else if (event.altKey && event.code === 'KeyL') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/parties";
                    let query = {type:'party'}
                    this.fn_navigateToNew(path, query, 'master');
                }
                else if (event.altKey && event.code === 'KeyM') {
                    event.preventDefault();
                    eventFired = true;
                    this.viaKeyboardShortCut = true;
                    let path = "/"+this.$route.params.businessId+"/items";
                    let query = {type:'item'}
                    this.fn_navigateToNew(path, query, 'master');
                }
            }
            
        });


    }
	
}